import React, { useState } from 'react'
import './set_new_bill.css'
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import DownloadIcon from '@mui/icons-material/Download';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import TextField from '@mui/material/TextField';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import InputAdornment from '@mui/material/InputAdornment';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import swal from 'sweetalert';

import Fab from '@mui/material/Fab';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { submit_new_bill, submit_new_order_bill, submit_new_contract_bill } from '../../../../services/supplier_service';




const useStyles = makeStyles((theme) => ({
    button: { margin: 8, },
    root: {
        '& > *': {
            margin: 8,
        },
    },
    input: {
        display: 'none',
    },
}));

function setDateTime(date) {
    let day = date.toISOString();
    let day_comp = day.split(":");
    return day_comp[0] + ":" + day_comp[1];
}

function Set_new_bill({ add_bill, setAdd_bill, id_submission, request_code, submit_new_bills, id_supplier, contract, order_infos }) {
   //  console.log(order_infos);

    const classes = useStyles();


    const [bill_content, setbill_content] = useState(null);
    const [reception_pv_doc, setreception_pv_doc] = useState(null);
    const [delivery_pv_doc, setdelivery_pv_doc] = useState(null);

    const [adminFileLoaded, setAdminFileLoaded] = useState();
    const [techFileLoaded, setTechFileLoaded] = useState();
    const [finFileLoaded, setFinFileLoaded] = useState();

    const [bill_number_value, setbill_number_value] = useState(null);
    const [bill_date, setbill_date] = useState("");
    const [limiteDate, setLimiteDate] = useState("");
    const [expiration_date,setExpiration_date]=useState("");


    const [errorText, setErrorText] = useState("");
    const [waiting, setWaiting] = useState(false);

    function DocNull() {
        setreception_pv_doc(null);
        setbill_content(null);
        setdelivery_pv_doc(null);
    }

    function upload_admin(event) {
        setbill_content(event.target.files[0]);
        setAdminFileLoaded(URL.createObjectURL(event.target.files[0]));
    }

    function upload_tech(event) {
        setreception_pv_doc(event.target.files[0]);
        setTechFileLoaded(URL.createObjectURL(event.target.files[0]));
    }

    function upload_fin(event) {
        setdelivery_pv_doc(event.target.files[0]);
        setFinFileLoaded(URL.createObjectURL(event.target.files[0]));
    }


    function downloadSupplierBillsDocs(choice) {
        var fileLink = document.createElement('a');
        if (choice === "bill") {
            fileLink.href = adminFileLoaded;
            fileLink.setAttribute('download', "facture");
            document.body.appendChild(fileLink);
            fileLink.click();
        }
        if (choice === "reception") {
            fileLink.href = techFileLoaded;
            fileLink.setAttribute('download', "pv_reception");
            document.body.appendChild(fileLink);
            fileLink.click();
        }
        if (choice === "delivery") {
            fileLink.href = finFileLoaded;
            fileLink.setAttribute('download', "pv_livraison");
            document.body.appendChild(fileLink);
            fileLink.click();
        }
    }

    function submit() {
        setErrorText('');

        // Basic validation
        if (!bill_content || !delivery_pv_doc) {
            setErrorText('Importez les documents !');
            return;
        }

        if (limiteDate=="" || !bill_number_value || bill_date=="" ) {
            setErrorText("Champs invalides !");
            return;
        }

        swal({
            title: "Êtes-vous sûr ?",
            text: "Vous êtes sur le point de soumettre une facture.",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willSubmit) => {
            if (!willSubmit) return;

            setWaiting(true);

            const formData = new FormData();
            formData.append('bill_number_value',bill_number_value);
            formData.append('bill_date',bill_date);
            formData.append('limit_date', limiteDate);
            formData.append('expiration_date',expiration_date);
            formData.append('bill_content', bill_content);
            formData.append('reception_pv', reception_pv_doc);
            formData.append('delivery_pv', delivery_pv_doc);

            // Determine submission type
            let submitPromise;

            if (request_code === undefined && contract !== undefined) {
                // Contract bill
                formData.append('id_contract', order_infos.id_contract);
                formData.append('id_supplier', id_supplier);
                submitPromise = submit_new_contract_bill(formData);
            } else if (request_code === undefined) {
                // Submission bill
                formData.append('id_submission', id_submission);
                submitPromise = submit_new_bill(formData);
            } else {
                // Order bill
                formData.append('request_code', request_code);
                formData.append('id_supplier', id_supplier);
                submitPromise = submit_new_order_bill(formData);
            }

            // Handle submission response
            submitPromise
                .then((response) => {
                    setWaiting(false);
                    submit_new_bills(response.data, add_bill);
                    setAdd_bill(null);
                    DocNull();
                })
                .catch((error) => {
                    setWaiting(false);
                    console.error(error);
                });
        });
    }



    return (
        <Dialog fullWidth={true} maxWidth={'md'} open={add_bill != null ? true : false} onClose={() => { setAdd_bill(null); setErrorText(''); }} aria-labelledby="form-dialog-title" >
            <DialogTitle id="form-dialog-title">Importez Vos Document !!</DialogTitle>
            <DialogContent>
                <div className='documentsContainer_BillsPage'>
                    <div className='comp_docs_container' style={{marginRight:"50px"}}>
                        <div className='documentsDownload'>
                            <label htmlFor="bill_content">
                                <Fab size="small" color="default" component="span" >
                                    <CloudUploadIcon className="my_icon" />
                                </Fab>
                                <input accept="application/*" className={classes.input} name="bill_content" id="bill_content" multiple type="file" onChange={(e) => upload_admin(e)} />
                            </label>
                            <Fab size="small" className={bill_content != null ? "" : " disabled_button"} onClick={() => downloadSupplierBillsDocs("bill")}><DownloadIcon className="my_icon" /></Fab>
                            <span className='documentsTitle'>Facture *</span>
                        </div>

                        <div className='documentsDownload'>
                            <label htmlFor="delivery_pv_doc">
                                <Fab size="small" color="default" component="span" >
                                    <CloudUploadIcon className="my_icon" />
                                </Fab>
                                <input accept="application/*" className={classes.input} name="delivery_pv_doc" id="delivery_pv_doc" multiple type="file" onChange={(e) => upload_fin(e)} />
                            </label>
                            <Fab size="small" className={delivery_pv_doc != null ? "" : " disabled_button"} onClick={() => downloadSupplierBillsDocs("delivery")}><DownloadIcon className="my_icon" /></Fab>
                            <span className='documentsTitle'>PV livraison *</span>
                        </div>

                        <div className='documentsDownload'>
                            <label htmlFor="reception_pv_doc">
                                <Fab size="small" color="default" component="span" >
                                    <CloudUploadIcon className="my_icon" />
                                </Fab>
                                <input accept="application/*" className={classes.input} name="reception_pv_doc" id="reception_pv_doc" multiple type="file" onChange={(e) => upload_tech(e)} />
                            </label>
                            <Fab size="small" className={reception_pv_doc != null ? "" : " disabled_button"} onClick={() => downloadSupplierBillsDocs("reception")}><DownloadIcon className="my_icon" /></Fab>
                            <span className='documentsTitle'>PV réception</span>
                        </div>

                    </div>
                    <div style={{flex:1}}>
                        <div style={{display:"flex" ,width:"100%"}}>
                            <TextField
                                type="text" variant='standard'
                                value={bill_number_value}
                                label="N° de la facture *" min={new Date()} className="header_form"
                                InputProps={{ startAdornment: (<InputAdornment position="start"> <BookmarkIcon className="my_icon" /> </InputAdornment>) }} onChange={(e) => setbill_number_value(e.target.value)}
                            />

                            <TextField
                                type="date" variant='standard'
                                value={bill_date}
                                label="Date de la facture *" min={new Date()} className="header_form"
                                InputProps={{ min: setDateTime(new Date()), startAdornment: (<InputAdornment position="start"> <BookmarkIcon className="my_icon" /> </InputAdornment>) }} onChange={(e) => setbill_date(e.target.value)}
                            />

                        </div>
                        
                        <div style={{display:"flex" ,width:"100%"}}>
                            <TextField
                                type="date" variant="standard"
                                className="header_form" label="Date d'échéance" min={new Date().toDateString()}
                                InputProps={{ startAdornment: ( <InputAdornment position="start"> <EventBusyIcon /> </InputAdornment> )}} onChange={(e)=>setExpiration_date(e.target.value)}
                            />
                            <TextField
                                type="date" variant='standard'
                                label="Date limite *" min={new Date()} className="header_form"
                                InputProps={{ min: setDateTime(new Date()), startAdornment: (<InputAdornment position="start"> <EventBusyIcon className="my_icon" /> </InputAdornment>) }} onChange={(e) => setLimiteDate(e.target.value)}
                            />
                        </div>
                    </div>
                
                </div>
            </DialogContent>
            <DialogActions>
                <div className='dialogBottom'>
                    <div>
                        {
                            errorText === ""
                                ? <></>
                                : <p className={errorText !== "" ? "col-md-10 error" : "col-md-10 valid-champ"}>
                                    {errorText}
                                </p>
                        }
                    </div>
                    <div>
                        <Button variant="contained" className="submit_but cancel_but" startIcon={<ClearIcon className="my_icon" />} onClick={() => { setAdd_bill(null); DocNull(); setErrorText(''); }} >
                            Annuler
                        </Button>
                        <Button variant="contained" className="submit_but valide_but" startIcon={<DoneIcon className="my_icon" />} onClick={() => submit()} >
                            Déposer
                        </Button>
                    </div>
                </div>
            </DialogActions>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Dialog>
    );
}

export default Set_new_bill
